import { Component, Input } from '@angular/core';
import { LoaderComponent } from './loader.component';

@Component({
  selector: 'app-loader-wrapper',
  template: `
    <ng-content></ng-content>
    @if (loading) {
      <app-loader [id]="id" [message]="message" [messageKey]="messageKey"></app-loader>
    }
  `,
  standalone: true,
  imports: [LoaderComponent],
})
export class LoaderWrapperComponent {
  @Input()
  loading = false;

  @Input()
  id: string;

  @Input()
  message: string;

  @Input()
  messageKey: string;
}
